import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
//import AddIcon from '@mui/icons-material/Add'

//components
import StyledPageContainer from '../../components/StyledPageContainer/StyledPageContainer'
import StyledTable from '../../components/ReactTable/StyledTable'
import StyledTableContainer from '../../components/StyledTableContainer/StyledTableContainer'
import StyledEmptyHeader from '../../components/StyledEmptyHeader/StyledEmptyHeader'
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal'
import AddOperationTypeModal from './AddOperationTypeModal'

//assets
import { DeleteIcon, EditIcon } from '../../icons/Icons'

//utils
import { showNotification } from '../../utils/toast.utils'

//services
import operationTypeService from '../../service/operationType.service'

const FilterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-between',
  alignItems: 'center',
  columnGap: '16px'
}))

const OperationType = () => {
  const [operationTypes, setOperationTypes] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [openAddModal, setOpenAddModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [openDeleteModal, setOpenDeleteModal] = useState(false)

  console.log(selectedItem)

  const fetchOperationTypes = async () => {
    try {
      setIsLoading(true)
      const response = await operationTypeService.getOperationTypes()

      if (response.success) {
        setOperationTypes(
          response.data.map((item, index) => ({
            index: index + 1,
            ...item
          }))
        )
      }
    } catch (err) {
      console.log(err)
      setOperationTypes([])
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchOperationTypes()
  }, [])

  const addOperationType = async (partType) => {
    if (!partType) {
      showNotification('Part type is required', 'error')
      return
    }

    const data = {
      type: partType
    }

    try {
      setIsLoading(true)
      const response = await operationTypeService.addOperationType(data)
      if (response.data.success) {
        showNotification(`Operation added successfully`, 'success')
      } else {
        showNotification(response.data.message, 'error')
      }
      setOpenAddModal(false)
      fetchOperationTypes()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  const editOperationType = async (id, partType) => {
    if (!partType) {
      showNotification('Part type is required', 'error')
      return
    }

    try {
      setIsLoading(true)
      const response = await operationTypeService.editOperationType(id, {
        type: partType
      })
      if (response.status === 200) {
        showNotification(`Part updated successfully`, 'success')
      } else {
        showNotification(response.data.message, 'error')
      }
      setOpenAddModal(false)
      fetchOperationTypes()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
      setIsEditMode(false)
    }
  }

  const deleteOperationType = async (partId) => {
    if (!partId) {
      showNotification('part id is required', 'error')
      return
    }

    try {
      setIsLoading(true)
      const response = await operationTypeService.deleteOperationType(partId)
      if (response.data.success) {
        showNotification(`Operation type deleted successfully`, 'success')
      } else {
        showNotification(response.data.message, 'error')
      }
      fetchOperationTypes()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  const partColumns = [
    {
      Header: 'S.No',
      accessor: 'index'
    },
    {
      Header: 'Id',
      accessor: 'id'
    },
    {
      Header: 'Operation',
      accessor: 'type'
    },
    // {
    //   Header: "Created by",
    //   accessor: "createdBy",
    // },
    {
      Header: 'Actions',
      Cell: ({ cell: { row } }) => {
        return (
          <div
            style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}
          >
            <EditIcon
              onClickHandler={() => {
                setIsEditMode(true)
                setSelectedItem({ ...row.values })
                setOpenAddModal(true)
              }}
            />
            <DeleteIcon
              onClickHandler={() => {
                setSelectedItem({ ...row.values })
                setOpenDeleteModal(true)
              }}
            />
          </div>
        )
      }
    }
  ]

  return (
    <>
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          width: '100%',
          flexDirection: 'column',
          gap: '12px',
          borderBottom: '1px solid #eeeeee',
          backgroundColor: '#fff',
          padding: '12px 16px',
          zIndex: 100
        }}
      >
      <FilterContainer>
        <Button
          //startIcon={<AddIcon />}
          variant="contained"
          sx={{
            textTransform: 'none',
            color: '#fff'
          }}
          onClick={() => {
            setIsEditMode(false)
            setSelectedItem({})
            setOpenAddModal(true)
          }}
        >
          Add operation type
        </Button>
      </FilterContainer>
      </Stack>
      <Box sx={{ padding: '16px' }}>
      <StyledTableContainer>
        {isLoading && <StyledEmptyHeader>Loading...</StyledEmptyHeader>}
        {!isLoading && operationTypes.length === 0 && (
          <StyledEmptyHeader>There are no parts</StyledEmptyHeader>
        )}
        {!isLoading && operationTypes.length > 0 && (
          <StyledTable
            pagination={false}
            columns={partColumns}
            data={operationTypes}
            hiddenColumns={['id']}
          />
        )}
      </StyledTableContainer>
      </Box>
      {openAddModal && (
        <AddOperationTypeModal
          closeHandler={() => setOpenAddModal(false)}
          isModalOpen={openAddModal}
          addPart={addOperationType}
          editPart={editOperationType}
          isEditMode={isEditMode}
          selectedPart={selectedItem}
        />
      )}
      {openDeleteModal && (
        <ConfirmationModal
          isModalOpen={openDeleteModal}
          description={`Do you want to delete the following operation type ${selectedItem.type}`}
          buttonTitle="Delete"
          clickHandler={() => deleteOperationType(selectedItem.id)}
          closeHandler={() => setOpenDeleteModal(false)}
        />
      )}
    </>
  )
}

export default OperationType
